module.exports = __webpack_public_path__ + "img/javascript.61ed8b05.svg";